import axiosInstance from "../../../../services/api/axiosInstance";
import backgroundAxiosInstance from "../../../../services/api/backgroundAxiosInstance";

export const getAllTeacher = async (obj) => {
    try {
        const response = await axiosInstance.get(`/teacher/all-teachers` , { params : obj});
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}

export const getAllTeacherAttendance = async (obj) => {
    try {
        const response = await axiosInstance.get(`/attendance/principal/teachers` , { params : obj});
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}
export const getTeacherAttendanceHistory = async (obj, isBackground) => {
    try {
        const response = await isBackground ? backgroundAxiosInstance.get(`/attendance/teacher/history`, {params : obj}) : axiosInstance.get(`/attendance/teacher/history`, {params : obj});
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}

export const teacherAttendanceCheckout = async (obj = {}) => {
    try {
        const response = await axiosInstance.patch(`/attendance/teacher/checkout`,obj);
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}

export const studentAttendanceMark = async (obj = {}) => {
    try {
        const response = await axiosInstance.post(`/attendance/student/bulk`,obj);
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}
export const getStudentAttendance = async (classId, obj) => {
    try {
        const response = await axiosInstance.get(`/attendance/students/class/${classId}`, {params : obj});
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}